import { render, staticRenderFns } from "./DeleteOrder.vue?vue&type=template&id=ae42fbe0&"
import script from "./DeleteOrder.vue?vue&type=script&lang=js&"
export * from "./DeleteOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports